import { render } from "./ViewHasilBerasa.vue?vue&type=template&id=08810892"
import script from "./ViewHasilBerasa.vue?vue&type=script&lang=js"
export * from "./ViewHasilBerasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__